/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames as cx } from '@ba-ui-toolkit/utils';
import SVGIcon from '@ba-ui-toolkit/svgicon';
import { DropTarget } from 'react-dnd';
import chevronRight16 from '@ba-ui-toolkit/ba-graphics/dist/icons-js/chevron-right_16.js';
import ItemTypes from './ItemTypes';

import './Tabs.scss';

const dropTarget = {};

function collect(connect, monitor) {
	return {
		connectDropTarget: connect.dropTarget(),
		isOver: monitor.isOver(),
	};
}

@DropTarget(ItemTypes.TAB, dropTarget, collect)
export class TabScrollButtonDnd extends Component {
	static propTypes = {
		connectDropTarget: PropTypes.func.isRequired,
	};

	render() {
		const { connectDropTarget, ...other } = this.props;

		return connectDropTarget(
			<div>
				<TabScrollButton {...other} />
			</div>
		);
	}
}

export default class TabScrollButton extends Component {
	static propTypes = {
		scrolling: PropTypes.bool,
		onClick: PropTypes.func,
		bottom: PropTypes.bool,
		top: PropTypes.bool,
		right: PropTypes.bool,
		left: PropTypes.bool,
		scrollHandler: PropTypes.func.isRequired,
		isOver: PropTypes.bool,
		backgroundColor: PropTypes.string,
		textColor: PropTypes.string,
		hoverColor: PropTypes.string,
	};

	constructor(props) {
		super(props);
		this.state = {
			scrollIntervalId: null,
			themeHover: false,
		};
	}

	componentDidUpdate(prevProps) {
		// check when the hover state has been entered or exited
		if (prevProps.isOver !== this.props.isOver) {
			if (this.props.isOver === true) {
				this.setState({
					scrollIntervalId: setInterval(() => {
						this.props.scrollHandler();
					}, 1000),
				});
			} else {
				clearInterval(this.state.scrollIntervalId);
			}
		}
	}

	themeHoverOn = () => {
		this.setState({ themeHover: true });
	};
	themeHoverOff = () => {
		this.setState({ themeHover: false });
	};

	configureAndGetWrapperStyling() {
		const { backgroundColor, textColor, hoverColor } = this.props;
		const themeBackgroundColor =
			this.state.themeHover && hoverColor ? hoverColor : backgroundColor;
		const shadowStyle = this.getShadowStyle();
		const style = {
			...(backgroundColor || hoverColor ? { backgroundColor: themeBackgroundColor } : {}),
			...(textColor ? { color: this.props.textColor } : {}),
			...shadowStyle,
		};

		return style;
	}

	getShadowStyle() {
		const { left, right, textColor = 'black' } = this.props;
		let style;
		if (left) {
			style = {
				boxShadow: `-6px 0px 12px 2px ${textColor}`,
			};
		} else if (right) {
			style = {
				boxShadow: `-6px 0px 12px -8px ${textColor}`,
			};
		}

		return style;
	}

	render() {
		const { bottom, top, left, right, onClick, scrolling } = this.props;
		const wrapperStyle = this.configureAndGetWrapperStyling();

		return (
			<div
				className={cx(
					'ba-common-tabList__edge__wrapper',
					{ visible: scrolling },
					{ bottom },
					{ top },
					{ left },
					{ right }
				)}
				onClick={onClick}
				onMouseEnter={this.themeHoverOn}
				onMouseLeave={this.themeHoverOff}
				style={wrapperStyle}
			>
				<div className={cx('ba-common-tabList__edge')} />
				<SVGIcon className="chevron-icon" iconId={chevronRight16.id} />
			</div>
		);
	}
}
